module.exports = __webpack_public_path__ + "img/tuhuang.b712abda.png";